import Vue from 'vue/dist/vue.esm.js'
import Select2Mixin from '../../mixins/select2_mixin.js.coffee'
PageSelect = {
  data: ->
    separators: [',']
  mixins: [Select2Mixin]
}

Vue.component('rf-new-document',
  template: JST['report_files/new_document_page_select']()
  props: ['pageCount', 'submitUrl', 'documentGroupCollection', 'reportFileId']
  data: ->
    message: {}
    documentGroupId: null
    disabled: false
    selectedPageNumbers: null
  computed:
    pageOptions: ->
      collection = []
      _(@pageCount).times (number) ->
        value = (number + 1).toString()
        collection.push([value, value])
      collection
  methods:
    submitNewDocument: ->
      AUTH_TOKEN = $('meta[name="csrf-token"]').attr('content')
      $.ajax
        dataType: 'JSON'
        method: 'POST'
        url: @submitUrl
        data: $.extend(@documentData(), { authenticity_token: AUTH_TOKEN })
        beforeSend: =>
          @disabled = true
        success: (data) =>
          window.open(data.url).focus()
          @message.text = data.message
          @message.class = 'alert-success'
          @selectedPageNumbers = null
          @disabled = false
        error: (data) =>
          @message.class = 'alert-danger'
          @message.text = data.message || I18n.t('notices.report_documents.failed_to_create')
          @disabled = false

    documentData: ->
      data =
        report_document:
          report_document_group_id: @documentGroupId
          report_file_id: @reportFileId
      if @selectedPageNumbers && @selectedPageNumbers.length > 0
        data['report_document']['file_page_numbers'] = @selectedPageNumbers.join(',')
      data


  components:
    pageSelect: PageSelect
    documentGroupSelect: Select2Mixin
)
